import { useState, useEffect } from "react";
import { useHistory } from "react-router";
import { sendRequest } from "../requests/useRequest";
import { useSweetAlert } from "../sweetAlerts/useSweetAlert";
import { useSignalR } from '../signalR/useSignalR';
import { useRef } from "react";

export const useGlobalNotifications = () => {
  const history = useHistory();
  const [hoveredId, setHoveredId] = useState(null);
  const [unreadCount, setUnreadCount] = useState(0);
  const [sections, setSections] = useState([]);
  // console.log("🌍 sections", sections);

  const messagesRef = useRef(null);

  const [createSweet] = useSweetAlert();

  useEffect(() => {
    fetchNotifications();
  }, []);

  const fetchNotifications = async () => {
    const response = await sendRequest("GET", "Notification/MyNotifications");

    if (Array.isArray(response?.data)) {
      setSections(response.data);

      const unread = response.data
        .flatMap(s => s.notifications || [])
        .filter(n => !n.read).length;

      setUnreadCount(unread);
    } else {
      setSections([]);
      setUnreadCount(0);
    }
  };

  useEffect(() => {
    const unread = sections
      .flatMap(s => s.notifications || [])
      .filter(n => !n.read).length;

    setUnreadCount(unread);
  }, [sections]);



  const removeNotification = async (id) => {
    await handleRequest("POST", `Notification/MarkAsRead?idNotification=${id}`);

    setSections(prev =>
      prev.map(sec => ({
        ...sec,
        notifications: sec.notifications.filter(n => n.id !== id)
      }))
      .filter(sec => sec.notifications.length > 0) 
    );

  };

  const fetchUnreadCount = async () => {
    const response = await handleRequest("GET", "Notification/CountUnread");
    if (response?.data !== undefined) {
      setUnreadCount(response.data);
    }
  };



  const handleMessage = async (data) => {
    // console.log("📩 SignalR:", data);

    if (messagesRef.current) {
      messagesRef.current.show({
        severity: "info",
        summary: data.title,
        detail: data.message,
        life: 9000
      });
    }

    await fetchNotifications();
  };

  const { conexion } = useSignalR({
    url: "/hub/notification",
    funcionRespuesta: handleMessage,
  });

  useEffect(() => {
    console.log("Estado SignalR:", conexion?.state);

  }, [conexion]);



  useEffect(() => {
    if (!conexion) return;

    if (conexion.state === "Connected") {
      // console.log("🟢 SignalR conectado");
    }
  }, [conexion]);


  const handleRequest = async (method, methodUrl, nameMethod, body = null) => {
    let requestOptions = {
      method: method
    };

    if (body !== null) {
      requestOptions = {
        ...requestOptions,
        body: JSON.stringify(body)
      };
    }

    const response = await sendRequest(requestOptions, methodUrl);

    if (response.code === 200) {
      return response.data;
    }
    else if (response.code === 404) {
      createSweet("info", "info", "Atención", response.data.msg);
    }
    else if (response.code === 500) {
    }
    else {
    }
    return null;
  }


  const handleNotificationAction = (notification) => {
    switch (notification.action_type) {
       
     case "FINANCE_AUTHORIZE":
      if (notification.id_work_order) {
        history.push(`/admisiones/${notification.id_work_order}/editar`);
      } else {
        console.log("No tiene id_work_order");
      }
      break;

      case "VIEW_RESULT":
        window.location.replace(`/micro/Reporte-Positividad`);

        break;

      default:
        console.log("Sin acción");
    }
  };


  const removeSectionNotifications = async (sectionName) => {

    const section = sections.find(s => s.section === sectionName);
    if (!section) return;

    try {

      await handleRequest(
        "DELETE",
        `Notification/DeleteSection?idSection=${section.id_section}`
      );

      setSections(prev =>
      prev.filter(sec => sec.section !== sectionName)
    );

      setUnreadCount(prev =>
        Math.max(prev - section.notifications.length, 0)
      );


    } catch (err) {
      console.error("Error eliminando sección", err);
    }
  };


  useEffect(() => {
    const refresh = () => fetchNotifications();

    window.addEventListener("refresh-notifications", refresh);

    return () => {
      window.removeEventListener("refresh-notifications", refresh);
    };
  }, []);



  return {
    sections,
    unreadCount,
    removeNotification,
    fetchUnreadCount,
    handleNotificationAction,
    setHoveredId,
    hoveredId,
    messagesRef,
    removeSectionNotifications,
    fetchNotifications,
    setSections
  };

};